export enum DefinitionSettingType {
  SubjectName = 1,
  SubjectCode = 2,
  SubjectNameWithSubjectCode = 3,
  SubjectCodeWithSubjectName = 4
}
